import { useGeo } from '../contexts/GeoContext';

// Displays a GBP amount converted to the visitor's chosen/local currency (display-only).
export const Price = ({ gbp }) => {
  const { format } = useGeo();
  return <>{format(gbp)}</>;
};

// Replace all "£X.XX" price mentions inside an HTML/text string with the
// visitor's chosen currency. `format` comes from useGeo(). Display-only.
export const localizePrices = (html, format) => {
  if (!html || typeof html !== 'string') return html;
  return html.replace(/£\s?(\d{1,4}(?:\.\d{1,2})?)/g, (_, n) => format(parseFloat(n)));
};

